// frontend/src/pages/ClientComputing/ClientAssets.js
import React from 'react';
import { Card, Typography, Empty } from 'antd';

const { Title, Paragraph } = Typography;

const ClientAssets = () => {
  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>Client Assets</Title>
      <Paragraph type="secondary">
        Register and manage End User Computing (EUC) devices.
      </Paragraph>

      <Card style={{ marginTop: 24 }}>
        <Empty
          description={
            <span>
              Coming soon — Client Assets management will be built here.
            </span>
          }
        />
      </Card>
    </div>
  );
};

export default ClientAssets;